import React, { FC } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { TrustPilotLogoSmall } from "../svg/svgs/TrustPilotLogoSmall";
import { FSCSSmall } from "../svg/svgs/FSCSSmall";
import Typography from "../typography/Typography";
import { graphql, useStaticQuery } from "gatsby";

// Interface

export interface TrustLogosProps {
  includeFscs?: boolean;
}

// Styles

const StyledTrustLogos = styled.a`
  ${({ theme: { colors, space, media, maxMedia } }) => css`
    text-decoration: none;
    div {
      display: flex;
      align-items: center;
      gap: ${space.medium};
    }

    @media (max-width: ${maxMedia.medium}) {
      div {
        margin-bottom: ${space.xxxSmall};
      }
    }
    @media (min-width: ${media.medium}) {
      display: flex;
      align-items: center;

      div {
        padding-right: ${space.medium};
        margin-right: ${space.medium};
        border-right: 1px solid ${colors.stone};
      }
    }
  `};
`;

// JSX

export const TrustLogos: FC<TrustLogosProps> = ({ includeFscs }) => {
  const { reviewSettings } = useStaticQuery(graphql`
    query {
      reviewSettings: umbracoTrustpilotSettingsType {
        reviewCount
        score
        link {
          ...Link
        }
      }
    }
  `);
  return (
    <StyledTrustLogos href={reviewSettings.link.url}>
      <div>
        <TrustPilotLogoSmall />
        {includeFscs && <FSCSSmall />}
      </div>
      <Typography component="p" variant="bodySmallMedium">
        {reviewSettings.reviewCount} {reviewSettings.score} star reviews on
        Trustpilot
        {includeFscs && (
          <>
            <br /> and FSCS protected{" "}
          </>
        )}
      </Typography>
    </StyledTrustLogos>
  );
};

export default TrustLogos;
